import { ItemLoader } from './ItemLoader';
import { GridContent } from './styled';
export function LoadingState() {
    return (<GridContent>
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
      <ItemLoader />
    </GridContent>);
}
